import React, { useState } from 'react';
import '../styles/GeneralStyles.css';
import imgStep1 from '../assets/img-step-1.png'
import imgColor1 from '../assets/img-corte-1.png'
import imgAnilloBodasPrev from '../assets/anillo-de-bodas-preview.webp'
import iconRadio1 from '../assets/ring-vector-1.svg'
import iconArrowLeft from '../assets/arrow-left.svg'
import iconArrowRight from '../assets/arrow-right.svg'

const Step6 = ({ nextStep, prevStep, handleInputChange, formData, isSubmitting }) => {
  const [selectedOption, setSelectedOption] = useState(formData?.material || null);

  const options = [
    {
      id: 1,
      icon: iconRadio1,
      text: "Oro Amarillo",
      value: 5413,
      title: "Oro Amarillo",
      description: "El oro amarillo, con su brillo cálido y atemporal, es una aleación de oro puro que garantiza durabilidad y elegancia en cada joya.",
      image: imgStep1,
    },
    {
      id: 2,
      icon: iconRadio1,
      text: "Oro Blanco",
      value: 5413,
      title: "Oro Blanco",
      description: "El oro blanco, sofisticado y moderno, es una aleación de oro puro con metales blancos que le dan su brillo elegante y duradero.",
      image: imgColor1
    },
    {
      id: 3,
      icon: iconRadio1,
      text: "Platino",
      value: 17500,
      title: "Platino",
      description: "El platino, raro y resistente, es un metal precioso de tono blanco natural que destaca por su durabilidad, pureza y elegancia atemporal.",
      image: imgColor1
    }
  ];

  const handleOptionSelect = (option) => {
    setSelectedOption(option);
    handleInputChange('material', option);
  };

  return (
    <div className='container-large'>
      <div className='wrapp-principal-2-columns'>
        <div className="options-column">
          <div className='text-n-options'>
            <h2 className='heading-style-h3 text-align-center'>Selecciona el material de tu anillo</h2>
            <p className='text-size-medium text-color-grey'>Personaliza si quieres tu anillo en oro amarillo, oro blanco, o platino.</p>
            <div className="radio-options">
              {options.map((option) => (
                <label key={option.id} className="radio-label">
                  <input
                    type="radio"
                    name="material"
                    checked={selectedOption?.id === option.id}
                    onChange={() => handleOptionSelect(option)}
                  />
                  <img src={option.icon} className="radio-icon" alt="ring icon" />
                  <span className="radio-text">{option.text}</span>
                </label>
              ))}
            </div>
          </div>
          
          <div className="wrapp-btns">
            <button className="button-prev" onClick={prevStep}>
              <img src={iconArrowLeft} alt="arrow left" />
              Volver
            </button>
            <button 
            className="button" 
            onClick={nextStep}
            disabled={!selectedOption}

            >
          Siguiente
          <img src={iconArrowRight} alt="arrow right" />
        </button>
            
          </div>
        </div>
        
        <div className="preview-column">
          {selectedOption ? (
            <>
              <div className='imgOptionSelected'>
                <img 
                  src={selectedOption.image} 
                  alt={selectedOption.text}
                  className="ring-preview-image"
                />
              </div>
              <div className='textOptionSelected'>
                <h3 className="text-align-left">{selectedOption.title}</h3>
                <p className="text-style-medium text-align-left">
                  {selectedOption.description}
                </p>
              </div>
            </>
          ) : (
            <div className="no-selection-message">
              <img src={imgAnilloBodasPrev} className='imgPreviewNoText' alt="Preview anillo" />
              <div className='wrappNoSelectText'>
                <p className='heading-style-h4 text-weight-bold text-color-white'>Material</p>
                <p className='text-size-large text-color-white'>Por favor selecciona el material</p>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Step6;
